module.exports = __webpack_public_path__ + "static/media/look-board.72856b1d.jpg";